module.exports = __webpack_public_path__ + "media/images/icon_a2_blue-711c252123c03a4101170ef49a58de89.png";